
































































import GlobalMixin from "@/shared/mixins/globalMixin";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import EstatisticasFunilCard from "./components/marketing/EstatisticasFunilCard.vue";
import ResultadosFunilCard from "./components/marketing/ResultadosFunilCard.vue";
import ConversaoLeadsCard from "./components/marketing/ConversaoLeadsCard.vue";
import TinhamosCard from "./components/marketing/TinhamosCard.vue";
import SairamCard from "./components/marketing/SairamCard.vue";
import EntraramCard from "./components/marketing/EntraramCard.vue";
import TaxaGeralCard from "./components/marketing/TaxaGeralCard.vue";
import GraficoCadastrosMarketingCard from "./components/marketing/GraficoCadastrosMarketingCard.vue";
import { DashboardService, TotalAssinantes } from "@/services/dashboard.service";

@Component({
  components: {
    EstatisticasFunilCard, ResultadosFunilCard, ConversaoLeadsCard, TinhamosCard, SairamCard, EntraramCard, TaxaGeralCard,
    GraficoCadastrosMarketingCard,
  },
})
export default class DashboardTvAtendimentos extends Mixins(GlobalMixin) {
  show = false;
  loading = false;
  totalAssinantes: TotalAssinantes[] | null = null;
  sairam: number | null = null;

  @Prop() date!: string | null;
  mesAtual: string | null = null;
  mesAnterior: string | null = null;

  mounted() {
    this.fetch();
  }

  @Watch("date")
  fetch() {
    this.show = true;
    if (!this.date) {
      this.mesAnterior = dayjs().subtract(1, 'month').format("YYYY-MM");
      this.mesAtual = dayjs().format("YYYY-MM");
    } else {
      this.mesAnterior = dayjs(this.date).subtract(1, 'month').format("YYYY-MM");
      this.mesAtual = dayjs(this.date).format("YYYY-MM");
    }
    dayjs.locale("pt-br");

    this.carregarAssinantes();
    this.carregarSaidas();
  }

  async carregarAssinantes() {
    this.loading = true;
    if (this.mesAnterior) {
      this.totalAssinantes = await DashboardService.Planos(
        this.mesAnterior
      ).finally(() => (this.loading = false));
    }
  }

  async carregarSaidas() {
    this.loading = true;
    if(this.mesAtual){
      this.sairam = await DashboardService.SairamMarketing(
        this.mesAtual
      ).finally(() => (this.loading = false));
    }
  }

  get totalPago(): number | null {
    if(!this.lastDayAssinantes){
      return null;
    }

    return this.lastDayAssinantes.totalpago;
  }

  get lastDayAssinantes(): TotalAssinantes | null{
    if(!this.totalAssinantes){
      return null;
    }

    return this.totalAssinantes[this.totalAssinantes.length - 1];
  }
}
